export default "/images/51f095f79f25de244723d5be86608e1c.avif";